import { useFetch } from "@/shared/hooks/fetch";
import { DocumentsController } from "@/shared/endpoints/documents";
import { IDocumentsGetResponse } from "@/shared/endpoints/documents/models/response";
import { Loading } from "@/shared/ui";

interface IProps {
    path: string;
    width?: number;
    bg?: boolean;
    className?: string;
    testId?: string;
}

//TODO: Discuss
const simpleCache: Record<string, IDocumentsGetResponse> = {};

const DocumentImage = ({ testId = 'base-document-image', path, width, bg, className }: IProps) => {
    const { data, loading } = useFetch(() => simpleCache[path] || DocumentsController.get(path), [path]);

    if (loading) return <Loading fitParent />;

    if (!data) return null;

    simpleCache[path] = data;

    return bg
        ? <div data-testid={testId} style={{ background: `url('${data.path}') center/contain no-repeat` }} className={className} />
        : <img data-testid={testId} width={width} src={data.path} alt="document image" className={className} />;
}

export default DocumentImage;